export default __webpack_public_path__ + "static/media/Yellow0006.56773e21.png";